mutation generateImage($input: GenerateImageInput!) {
  generatedImage: generateImage(input: $input) {
    id
    url
  }
}
